import type { CarrierCustomerAccountBinding, PurchaseOrder } from "@shared/types";
import { CellContext } from "@tanstack/react-table";
import { getMarketplaceDisplayName } from "../utils/get-marketplace-display-name";

interface OrderMarketplaceCellProps extends CellContext<PurchaseOrder, unknown> {
  carrierDetails?: CarrierCustomerAccountBinding[];
}

export const OrderMarketplaceCell = (props: OrderMarketplaceCellProps) => {
  const displayName = getMarketplaceDisplayName(props.row.original, props.carrierDetails);
  return <span className="text-sm truncate">{displayName}</span>;
};
